export const AREAS = [
  {
    id: 'gas-stations',
    title: 'Gas stations',
    icon: 'gas-station',
  },
  {
    id: 'convenience-retail',
    title: 'Convenience Retail',
    icon: 'conv-retail',
  },
  {
    id: 'hospitality',
    title: 'Hospitality',
    icon: 'hospitality',
  },
  {
    id: 'retail',
    title: 'Retail',
    icon: 'retail',
  },
];

export const PLANS = [
  {
    id: '1-10',
    title: '1-10',
  },
  {
    id: '11-20',
    title: '11-20',
  },
  {
    id: '21-50',
    title: '21-50',
  },
  {
    id: '50+',
    title: '50+',
  },
];

export const COUNTRIES = [
  {
    value: 1,
    label: 'Switzerland',
  },
  {
    value: 2,
    label: 'Germany',
  },
  {
    value: 3,
    label: 'Spain',
  },
];
